import jQuery from 'jquery';
import 'jquery-validate';
import { T_ } from '@shared/translation';

const emailRegExp = new RegExp(
  '^([\\w\\-\\+!#%\\*\\=\\?\\^\\{\\}\\|~]+' +
    '(?:\\.[\\w\\-\\+!#%\\*\\=\\?\\^\\{\\}\\|~]+)*)' +
    '@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,10}(?:\\.[a-z]{2})?)$',
  'i',
);

export const custom_validation_rules = {
  validate_username() {
    jQuery.validator.addMethod(
      'validateUsername',
      function(value, element) {
        return this.optional(element) || /^[a-z][a-z0-9]{2,15}$/i.test(value);
      },
      '',
    );
  },

  validateEmail() {
    jQuery.validator.addMethod(
      'validateEmailAddress',
      value => emailRegExp.test(value),
      T_('Please enter a valid email address'),
    );
  },

  validate_location() {
    jQuery.validator.addMethod('validateLocation', (value, element, params) => {
      const lat = params[0].val();
      const lng = params[1].val();

      return !(
        typeof lat === 'undefined' ||
        typeof lng === 'undefined' ||
        lat.length === 0 ||
        lng.length === 0
      );
    });
  },

  validate_password_strength() {
    jQuery.validator.addMethod(
      'validatePasswordStrength',
      val => {
        const len = val.length;
        const nums = val.match(/\d/g);
        const lowers = val.match(/[a-z]/g);
        const uppers = val.match(/[A-Z]/g);
        const pattern = /^.{6,}$/i;

        if (pattern.test(val)) {
          let strengthLevel = 0;
          if (nums) {
            strengthLevel += 2;
          }
          if (lowers) {
            strengthLevel += uppers ? 4 : 3;
          }
          if (uppers) {
            strengthLevel += lowers ? 4 : 3;
          }
          if (len > 10) {
            strengthLevel += 1;
          }

          if (strengthLevel <= 4) {
            return false;
          } else if (strengthLevel > 4 && strengthLevel <= 8) {
            return true;
          }

          return true;
        }
        return false;
      },
      '',
    );
  },

  different_from() {
    jQuery.validator.addMethod(
      'differentFrom',
      (value, element, params) =>
        params.reduce(
          (prevIsDiff, currParam) => prevIsDiff && currParam !== value,
          true,
        ),
      '',
    );
  },

  check_email_same() {
    jQuery.validator.addMethod(
      'passworddifferent',
      (value, element, params) => params[0] != jQuery(element).val(),
      '',
    );
  },

  not_equal() {
    jQuery.validator.addMethod(
      'notequal',
      (value, element, param) => value !== param.val(),
      '',
    );
  },

  passwords_match() {
    jQuery.validator.addMethod(
      'passwordsmatch',
      (value, element, params) => value === params[0].val(),
    );
  },

  email_not_blocked() {
    jQuery.validator.addMethod(
      'emailNotBlocked',
      value => {
        let isSuccess = true;

        jQuery.ajax({
          dataType: 'json',
          url: '/ajax/check-email-blocked.php',
          data: {
            email: value,
          },
          type: 'GET',
          async: false,
          success(resp) {
            if (!resp) {
              isSuccess = false;
            }
          },
          error() {
            isSuccess = false;
          },
        });
        return isSuccess;
      },
      T_('Please use a valid email address.'),
    );
  },
};
